export function generatePageTypeTrackingData(
  isAnonymous: boolean,
  isB2B: boolean,
  pageType: string,
  userId: string | undefined,
  numberOfOrders?: number,
  frameworkDiscount?: boolean
) {
  const trackingData = {
    user: {
      loginStatus: isAnonymous ? "logged-out" : "logged-in",
      type: isB2B ? "B2B" : "B2C",
    },
    page: {
      type: pageType,
    },
  }

  if (userId) {
    trackingData.user["id"] = userId
  }

  if (numberOfOrders) {
    trackingData.user["numberOfOrders"] = numberOfOrders
  }

  if (frameworkDiscount) {
    trackingData.user["frameworkDiscount"] = "" + frameworkDiscount
  }

  return trackingData
}
